
export const formTranslations = {
english: {
    title: "VITAMIN D DEFICIENCY RISK ASSESSMENT QUESTIONNAIRE",
    age: "Age",
    sectionA: "Section A: Basic Information",
    sectionB: "Section B: Questionnaire",
    select: "Select",
    yes: "Yes",
    no: "No",

    // q1 is derived from age (not rendered). q2 is asked directly.
    // Removed: q3, q4, q8, q10, q11
    questions: {
      q1: {
        text: "Age: Are you above 50 years of age?",
        options: ["Yes", "No"]
      },
      // q2: {
      //   text: "Body Type: Is your Body Mass Index (BMI) ≥ 30 kg/m² (Overweight/Obese)?",
      //   options: ["Yes", "No"]
      // },
      q5: {
        text: "Time Outdoors: On a typical day, how much time do you spend in the sun (between 11 AM - 3 PM) with your face, arms, and legs fully exposed?",
        options: ["Negligible", "Less than 30 minutes", "More than 30 minutes"]
      },
      q6: "Use of Sunscreen: Do you regularly apply sunscreen (SPF >15) on exposed skin before going out?",
      q7: "Location & Pollution: Do you live in a highly polluted urban area or a region with dense fog/smog for a large part of the year?",
      q9: "Milk/Fortified Food intake: Do you consume less than 2 cups (servings) of dairy/dairy products per day?",
      q12: "Diagnosis: Have you ever experienced a low-trauma fracture?",
      q13: {
        text: "Bone or Lower Back Pain: Do you often experience bone or lower back pain, muscle weakness, or fatigue affecting daily activity?",
        options: ["Often/Severe", "Sometimes", "No"]
      },
      q14: {
        text: "Muscle Weakness: Do you experience muscle weakness, like trouble climbing stairs or getting up from a chair?",
        options: ["Often/Severe", "Sometimes", "No"]
      },
      q15: {
        text: "Fatigue: Do you feel tired or low in energy even after rest?",
        options: ["Often/Severe", "Sometimes", "No"]
      },
      q16: {
        text: "Frequency of Illness: Do you fall sick more often than others (colds, flu and infections)?",
        options: ["Often/Severe", "Sometimes", "No"]
      },
      q17: {
        text: "Mood and Concentration: Do you notice low mood, irritability, or difficulty concentrating?",
        options: ["Often/Severe", "Sometimes", "No"]
      },
      q18: "Vitamin D Supplementation: Have you taken Vitamin D 60000 IU (Current or past 3 months)?"
    }
  },
  
  hindi: {
    title: "विटामिन D की कमी जोखिम मूल्यांकन प्रश्नावली",
    name: "नाम",
    age: "आयु",
    gender: "लिंग",
    male: "पुरुष",
    female: "महिला",
    height: "ऊंचाई",
    feet: "फीट",
    inches: "इंच",
    weight: "वजन",
    comorbidities: "रोगी के सह-रुग्णता",
    diabetes: "मधुमेह",
    hypertension: "उच्च रक्तचाप",
    hypothyroidism: "हाइपोथायरायडिज्म",
    hyperthyroidism: "हाइपरथायरायडिज्म",
    pcos: "पीसीओएस (पॉलीसिस्टिक ओवरी सिंड्रोम)",
    other: "कोई अन्य",
    patientInitials: "रोगी के आद्याक्षर",
    heightFeet: "रोगी के ऊंचाई (फीट)",
    heightInches: "रोगी के ऊंचाई (इंच)",
    weightKg: "रोगी के वजन (किलो)",
    otherComorbidity: "अन्य रुग्णता",
    sectionA: "खंड A: बुनियादी जानकारी",
    sectionB: "खंड B: प्रश्नावली",
    cancel: "रद्द करें",
    calculate: "स्कोर की गणना करें",
    selectGender: "लिंग चुनें",
    selectLanguage: "भाषा चुनें",
    select: "चुनें",
    yes: "हाँ",
    no: "नहीं",
    sometimes: "कभी-कभी",
    often: "अक्सर/गंभीर",
    dark: "गहरा",
    wheatish: "गेहुंआ",
    fair: "गोरा",
    veryFair: "बहुत गोरा",
    shorts: "शॉर्ट्स, टी-शर्ट, स्कर्ट",
    partialCoverage: "आंशिक कवरेज (जैसे साड़ी, आधी बाजू)",
    fullCoverage: "पूर्ण कवरेज (जैसे बुर्का, पूरी बाजू)",
    more30Min: "30 मिनट से अधिक",
    less30Min: "30 मिनट से कम",
    negligible: "नगण्य",
    noIntake: "कोई सेवन नहीं (शुद्ध शाकाहारी)",
    occasionalIntake: "कभी-कभी सेवन",
    regularIntake: "नियमित सेवन (मछली ≥1/सप्ताह)",
    
    questions: {
      q1: {
        text: "आयु: क्या आप 50 वर्ष से अधिक उम्र के हैं?",
        options: ["हाँ", "नहीं"]
      },
      q2: {
        text: "शारीरिक प्रकार: क्या आपका बॉडी मास इंडेक्स (BMI) ≥ 30 kg/m² (अधिक वजन/मोटापा) है?",
        options: ["हाँ", "नहीं"]
      },
      q3: {
        text: "त्वचा का रंग: आपकी त्वचा का रंग क्या है?",
        options: ["गहरा", "गेहुंआ", "गोरा", "बहुत गोरा"]
      },
      q4: {
        text: "कपड़ों की शैली: बाहर जाते समय आपके कपड़ों की सामान्य शैली क्या है?",
        options: ["शॉर्ट्स, टी-शर्ट, स्कर्ट", "आंशिक कवरेज (जैसे साड़ी, आधी बाजू)", "पूर्ण कवरेज (जैसे बुर्का, पूरी बाजू के कपड़े)"]
      },
      q5: {
        text: "बाहर समय: एक सामान्य दिन में, आप धूप में कितना समय बिताते हैं (सुबह 11 बजे से दोपहर 3 बजे के बीच)?",
        options: ["30 मिनट से अधिक", "30 मिनट से कम", "नगण्य"]
      },
      q6: "सनस्क्रीन का उपयोग: क्या आप बाहर जाने से पहले नियमित रूप से सनस्क्रीन (SPF >15) लगाते हैं?",
      q7: "स्थान और प्रदूषण: क्या आप वर्ष के बड़े हिस्से में अत्यधिक प्रदूषित शहरी क्षेत्र या घने कोहरे वाले क्षेत्र में रहते हैं?",
      q8: {
        text: "आप कितनी बार विटामिन D से भरपूर पशु-आधारित खाद्य पदार्थ (जैसे मछली, अंडे) का सेवन करते हैं?",
        options: ["कोई सेवन नहीं (शुद्ध शाकाहारी; कोई अंडा नहीं, कोई मछली नहीं)", "कभी-कभी सेवन (अंडा कुछ बार/सप्ताह, मछली बहुत कम)", "नियमित सेवन (मछली ≥1/सप्ताह या अंडे अक्सर)"]
      },
      q9: "दूध/फोर्टिफाइड भोजन: क्या आप प्रतिदिन 2 कप से कम डेयरी/डेयरी उत्पाद लेते हैं?",
      q10: "अवशोषण की स्थिति: क्या आपको यकृत रोग, IBD, सीलिएक रोग, या सिस्टिक फाइब्रोसिस जैसी स्थिति है जो वसा अवशोषण को प्रभावित करती है?",
      q11: "दवाएं: क्या आप दीर्घकालिक दवाएं (फ़िनाइटोइन, स्टेरॉयड, एंटिफंगल या एंटीरेट्रोवायरल) ले रहे हैं जो विटामिन D चयापचय को प्रभावित करती हैं?",
      q12: "ऑस्टियोपोरोसिस निदान: क्या आपको ऑस्टियोपोरोसिस, ऑस्टियोपीनिया का निदान हुआ है या कम आघात वाला फ्रैक्चर हुआ है?",
      q13: {
        text: "हड्डी या पीठ के निचले हिस्से में दर्द: क्या आप अक्सर हड्डी या पीठ के निचले हिस्से में दर्द, मांसपेशियों की कमजोरी, या थकान महसूस करते हैं?",
        options: [ "अक्सर/गंभीर", "कभी-कभी","नहीं"]
      },
      q14: {
        text: "मांसपेशियों की कमजोरी: क्या आप मांसपेशियों की कमजोरी अनुभव करते हैं, जैसे सीढ़ियाँ चढ़ने या कुर्सी से उठने में परेशानी?",
        options: [ "अक्सर/गंभीर", "कभी-कभी","नहीं"]
      },
      q15: {
        text: "थकान: क्या आप आराम के बाद भी थकान या ऊर्जा की कमी महसूस करते हैं?",
        options: [ "अक्सर/गंभीर", "कभी-कभी","नहीं"]
      },
      q16: {
        text: "बीमारी की आवृत्ति: क्या आप दूसरों की तुलना में अधिक बार बीमार पड़ते हैं (सर्दी, फ्लू और संक्रमण)?",
        options: [ "अक्सर/गंभीर", "कभी-कभी","नहीं"]
      },
      q17: {
        text: "मूड और एकाग्रता: क्या आप मूड में कमी, चिड़चिड़ापन, या ध्यान केंद्रित करने में कठिनाई महसूस करते हैं?",
        options:[ "अक्सर/गंभीर", "कभी-कभी","नहीं"]
      },
      q18: "विटामिन D सप्लिमेंटेशन: क्या आपने विटामिन D 60000 IU का सप्लिमेंट (वर्तमान या पिछले 3 महीनों में) लिया है?"
    }
  },
  
  telugu: {
    title: "విటమిన్ D లోపం ప్రమాద అంచనా ప్రశ్నావళి",
    name: "పేరు",
    age: "వయస్సు",
    gender: "లింగం",
    male: "పురుషుడు",
    female: "మహిళ",
    height: "ఎత్తు",
    feet: "అడుగులు",
    inches: "అంగుళాలు",
    weight: "బరువు",
    comorbidities: "రోగి అనుబంధ వ్యాధులు",
    diabetes: "మధుమేహం",
    hypertension: "రక్తపోటు",
    hypothyroidism: "హైపోథైరాయిడిజం",
    hyperthyroidism: "హైపర్‌థైరాయిడిజం",
    pcos: "పీసీఓఎస్ (పాలీసిస్టిక్ ఓవరీ సిండ్రోమ్)",
    other: "ఇతర వ్యాధులు",
    patientInitials: "రోగి పేరు మొదటి అక్షరాలు",
    heightFeet: "రోగి ఎత్తు (అడుగులు)",
    heightInches: "రోగి ఎత్తు (అంగుళాలు)",
    weightKg: "రోగి బరువు (కిలోలు)",
    otherComorbidity: "ఇతర వ్యాధి",
    sectionA: "విభాగం A: ప్రాథమిక సమాచారం",
    sectionB: "విభాగం B: ప్రశ్నావళి",
    cancel: "రద్దు చేయి",
    calculate: "స్కోర్ లెక్కించండి",
    selectGender: "లింగం ఎంచుకోండి",
    selectLanguage: "భాష ఎంచుకోండి",
    select: "ఎంచుకోండి",
    yes: "అవును",
    no: "లేదు",
    sometimes: "కొన్నిసార్లు",
    often: "తరచుగా/తీవ్రమైన",
    dark: "ముదురు",
    wheatish: "గోధుమ",
    fair: "లేత",
    veryFair: "చాలా లేత",
    shorts: "షార్ట్స్, టీ-షర్టులు, స్కర్టులు",
    partialCoverage: "పాక్షిక కవరేజ్ (ఉదా. చీర, సగం చేతులు)",
    fullCoverage: "పూర్తి కవరేజ్ (ఉదా. బుర్ఖా, పూర్తి చేతులు)",
    more30Min: "30 నిమిషాల కంటే ఎక్కువ",
    less30Min: "30 నిమిషాల కంటే తక్కువ",
    negligible: "చాలా తక్కువ",
    noIntake: "తీసుకోవడం లేదు (పూర్తి శాకాహారం)",
    occasionalIntake: "అప్పుడప్పుడు తీసుకోవడం",
    regularIntake: "క్రమం తప్పకుండా తీసుకోవడం (చేప ≥1/వారం)",
    
    questions: {
      q1: {
        text: "వయస్సు: మీరు 50 సంవత్సరాల కంటే ఎక్కువ వయస్సు ఉన్నారా?",
        options: ["అవును", "లేదు"]
      },
      q2: {
        text: "శరీర రకం: మీ బాడీ మాస్ ఇండెక్స్ (BMI) ≥ 30 kg/m² (అధిక బరువు/ఊబకాయం) ఉందా?",
        options: ["అవును", "లేదు"]
      },
      q3: {
        text: "చర్మ వర్ణం: మీ చర్మ టోన్ ఏమిటి?",
        options: ["ముదురు", "గోధుమ", "లేత", "చాలా లేత"]
      },
      q4: {
        text: "దుస్తుల శైలి: బయటికి వెళ్ళేటప్పుడు మీ సాధారణ దుస్తుల శైలి ఏమిటి?",
        options: ["షార్ట్స్, టీ-షర్టులు, స్కర్టులు", "పాక్షిక కవరేజ్ (ఉదా. చీర, సగం చేతులు)", "పూర్తి కవరేజ్ (ఉదా. బుర్ఖా, పూర్తి చేతుల దుస్తులు)"]
      },
      q5: {
        text: "బయట సమయం: సాధారణ రోజులో, మీరు ఎంత సమయం ఎండలో గడుపుతారు (ఉదయం 11 నుండి మధ్యాహ్నం 3 మధ్య)?",
        options: ["30 నిమిషాల కంటే ఎక్కువ", "30 నిమిషాల కంటే తక్కువ", "చాలా తక్కువ"]
      },
      q6: "సన్‌స్క్రీన్ వాడకం: మీరు బయటికి వెళ్లేముందు క్రమం తప్పకుండా సన్‌స్క్రీన్ (SPF >15) రాసుకుంటారా?",
      q7: "స్థానం & కాలుష్యం: మీరు సంవత్సరంలో ఎక్కువ భాగం చాలా కాలుష్యం ఉన్న పట్టణ ప్రాంతంలో లేదా దట్టమైన పొగమంచు ఉన్న ప్రాంతంలో నివసిస్తున్నారా?",
      q8: {
        text: "మీరు విటమిన్ D సమృద్ధిగా ఉన్న జంతు ఆహారాలు (ఉదా. చేపలు, గుడ్లు) ఎంత తరచుగా తీసుకుంటారు?",
        options: ["తీసుకోవడం లేదు (పూర్తి శాకాహారం; గుడ్డు లేదు, చేప లేదు)", "అప్పుడప్పుడు తీసుకోవడం (గుడ్డు కొన్నిసార్లు/వారం, చేప చాలా తక్కువ)", "క్రమం తప్పకుండా తీసుకోవడం (చేప ≥1/వారం లేదా గుడ్లు తరచుగా)"]
      },
      q9: "పాలు/ఫోర్టిఫైడ్ ఆహారం: మీరు రోజుకు 2 కప్పుల కంటే తక్కువ డెయిరీ/డెయిరీ ఉత్పత్తులు తీసుకుంటారా?",
      q10: "శోషణ పరిస్థితులు: మీకు కాలేయ వ్యాధి, IBD, సెలియాక్ వ్యాధి, లేదా సిస్టిక్ ఫైబ్రోసిస్ వంటి కొవ్వు శోషణను ప్రభావితం చేసే పరిస్థితి ఉందా?",
      q11: "మందులు: మీరు విటమిన్ D జీవక్రియను ప్రభావితం చేసే దీర్ఘకాలిక మందులు (ఫెనిటోయిన్, స్టెరాయిడ్లు, యాంటిఫంగల్స్ లేదా యాంటిరెట్రోవైరల్) తీసుకుంటున్నారా?",
      q12: "ఆస్టియోపోరోసిస్ నిర్ధారణ: మీకు ఆస్టియోపోరోసిస్, ఆస్టియోపీనియా నిర్ధారణ జరిగిందా లేదా తక్కువ గాయం ఫ్రాక్చర్ అనుభవించారా?",
      q13: {
        text: "ఎముక లేదా వెన్ను నొప్పి: మీరు తరచుగా ఎముక లేదా వెన్ను నొప్పి, కండరాల బలహీనత, లేదా రోజువారీ కార్యకలాపాలను ప్రభావితం చేసే అలసట అనుభవిస్తున్నారా?",
        options: ["తరచుగా/తీవ్రమైన","కొన్నిసార్లు", "లేదు"]
      },
      q14: {
        text: "కండరాల బలహీనత: మీరు కండరాల బలహీనత అనుభవిస్తున్నారా, అంటే మెట్లు ఎక్కడం లేదా కుర్చీ నుండి లేవడంలో ఇబ్బంది?",
        options: ["తరచుగా/తీవ్రమైన","కొన్నిసార్లు", "లేదు"]
      },
      q15: {
        text: "అలసట: మీరు విశ్రాంతి తర్వాత కూడా అలసిపోయినట్లు లేదా శక్తి తక్కువగా ఉన్నట్లు అనిపిస్తుందా?",
        options: ["తరచుగా/తీవ్రమైన","కొన్నిసార్లు", "లేదు"]
      },
      q16: {
        text: "అనారోగ్య పౌనఃపున్యం: మీరు ఇతరుల కంటే తరచుగా అనారోగ్యంతో (జలుబు, ఫ్లూ మరియు ఇన్ఫెక్షన్లు) బాధపడుతున్నారా?",
        options: ["తరచుగా/తీవ్రమైన","కొన్నిసార్లు", "లేదు"]
      },
      q17: {
        text: "మానసిక స్థితి మరియు ఏకాగ్రత: మీరు తక్కువ మానసిక స్థితి, చిరాకు, లేదా ఏకాగ్రతలో ఇబ్బంది గమనిస్తున్నారా?",
        options:["తరచుగా/తీవ్రమైన","కొన్నిసార్లు", "లేదు"]
      },
q18: "విటమిన్ D సప్లిమెంటేషన్: మీరు విటమిన్ D 60000 IU సప్లిమెంట్‌ను (ప్రస్తుతం లేదా గత 3 నెలల్లో) తీసుకున్నారా?"
    }
  },

marathi: {
    title: "व्हिटॅमिन D कमतरता जोखीम मूल्यांकन प्रश्नावली",
    name: "नाव",
    age: "रुग्णाचे वय",
    gender: "रुग्णाचे लिंग",
    male: "पुरुष",
    female: "महिला",
    height: "उंची",
    feet: "फुट",
    inches: "इंच",
    weight: "वजन",
    comorbidities: "रुग्णाच्या सह-रुग्णता",
    diabetes: "मधुमेह",
    hypertension: "उच्च रक्तदाब",
    hypothyroidism: "हायपोथायरॉईडिझम",
    hyperthyroidism: "हायपरथायरॉईडिझम",
    pcos: "पीसीओएस (पॉलिसिस्टिक ओव्हरी सिंड्रोम)",
    other: "इतर",
    patientInitials: "रुग्णाचे आद्याक्षरे",
    heightFeet: "रुग्णाची उंची (फुट)",
    heightInches: "रुग्णाची उंची (इंच)",
    weightKg: "रुग्णाचे वजन (किलो)",
    otherComorbidity: "इतर सह-रुग्णता",
    sectionA: "विभाग A: मूलभूत माहिती",
    sectionB: "विभाग B: प्रश्नावली",
    cancel: "रद्द करा",
    calculate: "स्कोअर मोजा",
    selectGender: "लिंग निवडा",
    selectLanguage: "भाषा निवडा",
    select: "निवडा",
    yes: "होय",
    no: "नाही",
    sometimes: "कधी कधी",
    often: "वारंवार / गंभीर",
    dark: "काळा",
    wheatish: "गव्हाळ",
    fair: "गोरा",
    veryFair: "खूप गोरा",
    shorts: "शॉर्ट्स, टी-शर्ट, स्कर्ट",
    partialCoverage: "अंशतः झाकणारे (उदा. साडी, अर्धी बाह्य)",
    fullCoverage: "पूर्णपणे झाकणारे (उदा. बुर्का, पूर्ण बाह्यांचे कपडे)",
    more30Min: "३० मिनिटांपेक्षा जास्त",
    less30Min: "३० मिनिटांपेक्षा कमी",
    negligible: "अत्यल्प",
    noIntake: "कधीही सेवन नाही (शुद्ध शाकाहारी/व्हेगन)",
    occasionalIntake: "कधीकधी सेवन",
    regularIntake: "नियमित सेवन (मासे ≥ आठवड्यातून १ वेळ)",

    questions: {
      q1: {
        text: "वय: तुम्ही ५० वर्षांपेक्षा जास्त आहात का?",
        options: ["होय", "नाही"]
      },
      q2: {
        text: "शारीरिक प्रकार: तुमचा BMI ≥ 30 kg/m² आहे का (जाड/अतिजाड)?",
        options: ["होय", "नाही"]
      },
      q3: {
        text: "त्वचेचा रंग: तुमचा त्वचेचा रंग कोणता?",
        options: ["काळा", "गव्हाळ", "गोरा", "खूप गोरा"]
      },
      q4: {
        text: "वेशभूषा शैली: बाहेर जाताना तुम्ही कोणत्या प्रकारचे कपडे घालता?",
        options: ["शॉर्ट्स, टी-शर्ट, स्कर्ट", "अर्धवट झाकणारे (उदा. साडी, अर्धी बाह्य सलवार)", "पूर्णपणे झाकणारे (उदा. बुर्का, पूर्ण बाह्य कपडे)"]
      },
      q5: {
        text: "सूर्यप्रकाशातील वेळ: सामान्य दिवशी सकाळी ११ ते दुपारी ३ दरम्यान चेहरा, हात-पाय उघडे ठेवून तुम्ही किती वेळ सूर्यप्रकाशात राहता?",
        options: ["अत्यल्प", "৩০ मिनिटांपेक्षा कमी", "৩০ मिनिटांपेक्षा जास्त"]
      },
      q6: "सन्स्क्रीन वापर: तुम्ही SPF > 15 असलेली सन्स्क्रीन नियमितपणे वापरता का?",
      q7: "स्थान व प्रदूषण: तुम्ही अत्यंत प्रदूषित किंवा धुक्याच्या प्रदेशात राहता का?",
      q8: {
        text: "व्हिटॅमिन Dयुक्त मांसाहारी पदार्थ (मासे, अंडी) किती वेळा सेवन करता?",
        options: ["सेवन नाही (शुद्ध शाकाहारी/व्हेगन; अंडी/मासे नाही)", "कधीकधी सेवन (फक्त अंडी, मासे खूप कमी)", "नियमित सेवन (मासे ≥ आठवड्यातून १ वेळ किंवा अंडी वारंवार)"]
      },
      q9: "दूध/फॉर्टिफाइड अन्न: तुम्ही दिवसाला २ कपांपेक्षा कमी दूध किंवा दुग्धजन्य पदार्थ घेताय का?",
      q10: "शोषणासंबंधी आजार: तुम्हाला यकृत रोग, IBD, सिलिआक किंवा सिस्टिक फायब्रॉसिस यांसारखा शोषण कमी करणारा आजार आहे का?",
      q11: "औषधे: तुम्ही लांबकालीन फेनिटॉईन, स्टेरॉइड्स, अँटीफंगल किंवा अँटीरेट्रोव्हायरल औषधे घेत आहात का?",
      q12: "ऑस्टिओपोरोसिस निदान: तुम्हाला ऑस्टिओपोरोसिस, ऑस्टिओपेनिया किंवा किरकोळ आघातामुळे हाड मोडले आहे का?",
      q13: {
        text: "हाड/कंबरदुखी: तुम्हाला वारंवार हाड दुखणे, कंबरदुखी, स्नायू कमजोरी किंवा थकवा जाणवतो का?",
        options: ["वारंवार / गंभीर", "कधी कधी", "नाही"]
      },
      q14: {
        text: "स्नायू कमजोरी: पायऱ्या चढताना किंवा खुर्चीतून उठताना स्नायूंमध्ये कमजोरी जाणवते का?",
        options: ["वारंवार / गंभीर", "कधी कधी", "नाही"]
      },
      q15: {
        text: "थकवा: विश्रांती घेतल्यानंतरही तुम्हाला थकल्यासारखे वाटते का?",
        options: ["वारंवार / गंभीर", "कधी कधी", "नाही"]
      },
      q16: {
        text: "सर्दी/ताप: इतरांच्या तुलनेत तुम्हाला वारंवार सर्दी, ताप किंवा इन्फेक्शन होते का?",
        options: ["वारंवार / गंभीर", "कधी कधी", "नाही"]
      },
      q17: {
        text: "मन:स्थिती: तुम्हाला खिन्नपणा, चिडचिड किंवा एकाग्रता कमी झाल्यासारखे वाटते का?",
        options: ["वारंवार / गंभीर", "कधी कधी", "नाही"]
      },
q18: "व्हिटामिन D सप्लिमेंटेशन: तुम्ही सध्या किंवा गेल्या 3 महिन्यांत व्हिटामिन D 60000 IU सप्लिमेंट घेतले आहे का?"
    }
}
,


bengali: {
  title: "ভিটামিন D ঘাটতির ঝুঁকি মূল্যায়ন প্রশ্নাবলী",
  name: "নাম",
  age: "রোগীর বয়স",
  gender: "রোগীর লিঙ্গ",
  male: "পুরুষ",
  female: "মহিলা",
  height: "উচ্চতা",
  feet: "ফুট",
  inches: "ইঞ্চি",
  weight: "ওজন",
  comorbidities: "রোগীর সহ-রোগ",
  diabetes: "ডায়াবেটিস",
  hypertension: "উচ্চ রক্তচাপ",
  hypothyroidism: "হাইপোথাইরয়েডিজম",
  hyperthyroidism: "হাইপারথাইরয়েডিজম",
  pcos: "PCOS (পলিসিস্টিক ওভারি সিনড্রোম)",
  other: "অন্যান্য",
  patientInitials: "রোগীর নামের প্রথম অক্ষর",
  heightFeet: "রোগীর উচ্চতা (ফুট)",
  heightInches: "রোগীর উচ্চতা (ইঞ্চি)",
  weightKg: "রোগীর ওজন (কেজি)",
  otherComorbidity: "অন্যান্য সহ-রোগ",
  sectionA: "সেকশন A: প্রাথমিক তথ্য",
  sectionB: "সেকশন B: প্রশ্নাবলী",
  cancel: "বাতিল",
  calculate: "স্কোর গণনা করুন",
  selectGender: "লিঙ্গ নির্বাচন করুন",
  selectLanguage: "ভাষা নির্বাচন করুন",
  select: "নির্বাচন করুন",
  yes: "হ্যাঁ",
  no: "না",
  sometimes: "কখনও কখনও",
  often: "প্রায়ই / তীব্র",
  dark: "গাঢ়",
  wheatish: "গম-রঙা",
  fair: "ফর্সা",
  veryFair: "খুব ফর্সা",
  shorts: "কম ঢাকা পোশাক (শর্টস, টি-শার্ট, স্কার্ট ইত্যাদি)",
  partialCoverage: "আংশিক ঢাকা পোশাক (যেমন – শাড়ি, অর্ধহাতা পোশাক)",
  fullCoverage: "সম্পূর্ণ ঢাকা পোশাক (যেমন – বোরখা বা পূর্ণহাতা পোশাক)",
  more30Min: "৩০ মিনিটের বেশি",
  less30Min: "৩০ মিনিটের কম",
  negligible: "খুবই কম",
  noIntake: "সম্পূর্ণভাবে গ্রহণ করেন না (পূর্ণ নিরামিষ / ভেগান)",
  occasionalIntake: "মাঝে মাঝে গ্রহণ",
  regularIntake: "নিয়মিত গ্রহণ (সপ্তাহে ≥১ বার মাছ বা প্রায়ই ডিম)",
  
  questions: {
    q1: {
      text: "বয়স: আপনার বয়স কি ৫০ বছরের বেশি?",
      options: ["হ্যাঁ", "না"]
    },
    q2: {
      text: "শরীরের গঠন: আপনার BMI কি ৩০ kg/m² বা তার বেশি (অতিরিক্ত ওজন / স্থূলতা)?",
      options: ["হ্যাঁ", "না"]
    },
    q3: {
      text: "ত্বকের রঙ: আপনার ত্বকের রঙ কেমন?",
      options: ["গাঢ়", "গম-রঙা", "ফর্সা", "খুব ফর্সা"]
    },
    q4: {
      text: "পোশাকের ধরন: বাইরে গেলে আপনি সাধারণত কী ধরনের পোশাক পরেন?",
      options: ["কম ঢাকা পোশাক", "আংশিক ঢাকা পোশাক", "সম্পূর্ণ ঢাকা পোশাক"]
    },
    q5: {
      text: "সূর্যালোকে থাকা সময়: সকাল ১১টা থেকে দুপুর ৩টার মধ্যে মুখ, হাত ও পা খোলা রেখে আপনি সাধারণত কতক্ষণ রোদে থাকেন?",
      options: ["খুবই কম", "৩০ মিনিটের কম", "৩০ মিনিটের বেশি"]
    },
    q6: "সানস্ক্রিন ব্যবহার: আপনি কি SPF ১৫-এর বেশি যুক্ত সানস্ক্রিন বাইরে যাওয়ার আগে নিয়মিত ব্যবহার করেন?",
    q7: "অবস্থান ও দূষণ: আপনি কি অত্যন্ত দূষিত শহরাঞ্চলে অথবা এমন জায়গায় থাকেন যেখানে সারা বছর ধোঁয়া বা কুয়াশা থাকে?",
    q8: {
      text: "ভিটামিন D-সমৃদ্ধ প্রাণিজ খাদ্য (মাছ, ডিম) কতবার গ্রহণ করেন?",
      options: ["গ্রহণ করেন না (পূর্ণ নিরামিষ / ভেগান)", "মাঝে মাঝে গ্রহণ", "নিয়মিত গ্রহণ (মাছ সপ্তাহে ≥১ বার বা ডিম প্রায়ই)"]
    },
    q9: "দুধ / পুষ্টিকর খাদ্য: আপনি কি দিনে ২ কাপের কম দুধ বা দুগ্ধজাত খাদ্য গ্রহণ করেন?",
    q10: "শোষণজনিত রোগ: আপনার কি এমন কোনো রোগ আছে যা চর্বি শোষণ প্রক্রিয়ায় প্রভাব ফেলে—যেমন লিভারের রোগ, IBD, সিলিয়াক ডিজিজ বা সিস্টিক ফাইব্রোসিস?",
    q11: "ওষুধ: আপনি কি দীর্ঘদিন ধরে ফেনিটয়িন, স্টেরয়েড, অ্যান্টিফাঙ্গাল বা HIV-এর অ্যান্টিরেট্রোভাইরাল ওষুধ গ্রহণ করছেন?",
    q12: "হাড়ের রোগ: আপনার কি অস্টিওপোরোসিস, অস্টিওপেনিয়া বা অল্প আঘাতে হাড় ভেঙে যাওয়ার অভিজ্ঞতা আছে?",
    q13: {
      text: "হাড় বা কোমর ব্যথা: হাড় ব্যথা, কোমর ব্যথা, পেশি দুর্বলতা বা ক্লান্তি কি দৈনন্দিন কাজে বাধা তৈরি করে?",
      options: ["প্রায়ই / তীব্র", "কখনও কখনও", "না"]
    },
    q14: {
      text: "পেশি দুর্বলতা: সিঁড়ি ওঠা বা চেয়ার থেকে ওঠার সময় কি আপনার কষ্ট হয়?",
      options: ["প্রায়ই / তীব্র", "কখনও কখনও", "না"]
    },
    q15: {
      text: "ক্লান্তি: যথেষ্ট বিশ্রাম নেওয়ার পরও কি আপনার ক্লান্তি বা শক্তির অভাব অনুভূত হয়?",
      options: ["প্রায়ই / তীব্র", "কখনও কখনও", "না"]
    },
    q16: {
      text: "বারবার অসুস্থ হওয়া: আপনি কি অন্যদের তুলনায় বেশি সর্দি, জ্বর বা সংক্রমণে আক্রান্ত হন?",
      options: ["প্রায়ই / তীব্র", "কখনও কখনও", "না"]
    },
    q17: {
      text: "মনের অবস্থা ও মনোযোগ: আপনার কি মন খারাপ লাগে, রাগ হয় বা মনোযোগে ঘাটতি হয়?",
      options: ["প্রায়ই / তীব্র", "কখনও কখনও", "না"]
    },
q18: "ভিটামিন D সাপ্লিমেন্টেশন: আপনি বর্তমানে বা গত ৩ মাসে ভিটামিন D  60000 IU সাপ্লিমেন্ট গ্রহণ করেছেন কি?"
  }
}


,

  bhojpuri: {
  title: "विटामिन D के कमी के जोखिम मूल्यांकन प्रश्नावली",
  name: "नाव",
  age: "मरीज़ के उमिर",
  gender: "मरीज़ के लिंग",
  male: "पुरुष",
  female: "औरत",
  height: "कद",
  feet: "फुट",
  inches: "इंच",
  weight: "वजन",
  comorbidities: "मरीज़ के साथ मौजूद दोसर बीमारी",
  diabetes: "शुगर (मधुमेह)",
  hypertension: "हाई ब्लड प्रेशर",
  hypothyroidism: "हाइपोथायरॉइडिज्म",
  hyperthyroidism: "हाइपरथायरॉइडिज्म",
  pcos: "पी.सी.ओ.एस. (पॉलीसिस्टिक ओवरी सिन्ड्रोम)",
  other: "अउर कुछ",
  patientInitials: "मरीज़ के शुरुआती अक्षर",
  heightFeet: "मरीज़ के कद (फुट)",
  heightInches: "मरीज़ के कद (इंच)",
  weightKg: "मरीज़ के वजन (किलो)",
  otherComorbidity: "अउर मौजूद बीमारी",
  sectionA: "सेक्शन A: बुनियादी जानकारी",
  sectionB: "सेक्शन B: प्रश्नावली",
  cancel: "रद्द करीं",
  calculate: "स्कोर निकालल जाय",
  selectGender: "लिंग चुनीं",
  selectLanguage: "भाषा चुनीं",
  select: "चुनीं",
  yes: "हाँ",
  no: "ना",
  sometimes: "कभी-कभी",
  often: "बार-बार / गंभीर",
  dark: "गहरा रंग (काला)",
  wheatish: "गेहुआ रंग",
  fair: "गोरा",
  veryFair: "बहुत गोरा",
  shorts: "कम ढँकल वाला कपड़ा (शॉर्ट्स, टी-शर्ट, स्कर्ट वगैरह)",
  partialCoverage: "आधा ढँकल वाला कपड़ा (जैसे – साड़ी, आधा बाँह के कपड़ा)",
  fullCoverage: "पूरा ढँकल वाला कपड़ा (जैसे – बुर्का, पूरा बाँह वाला कपड़ा)",
  more30Min: "30 मिनट से जादे",
  less30Min: "30 मिनट से कम",
  negligible: "बहुत कम",
  noIntake: "बिल्कुल सेवन ना (पूरी तरही साकाहारी / वेगन)",
  occasionalIntake: "कभी-कभी सेवन",
  regularIntake: "नियमित सेवन (हफ्ता में एक बार से जादे माछ या रोज अंडा)",
  
  questions: {
    q1: {
      text: "उमिर: का आप 50 साल से जादे उमिर के बानी?",
      options: ["हाँ", "ना"]
    },
    q2: {
      text: "शरीर के आकार: का तोहार BMI 30 kg/m² से ऊपर बा (अधिक वजन / मोटापा)?",
      options: ["हाँ", "ना"]
    },
    q3: {
      text: "त्वचा के रंग: तोहरे चमड़ा के रंग कइसन बा?",
      options: ["गहरा (काला)", "गेहुआ", "गोरा", "बहुत गोरा"]
    },
    q4: {
      text: "कपड़ा पहनावे के तरीका: बाहर जात बाड़ऽ त आमतौर पर कइसन कपड़ा पहिरेनी?",
      options: ["कम ढँकल वाला कपड़ा (शॉर्ट्स, टी-शर्ट, स्कर्ट)", "आधा ढँकल वाला (साड़ी/आधा बाँह के कपड़ा)", "पूरा ढँकल वाला (बुर्का/पूरा बाँह के कपड़ा)"]
    },
    q5: {
      text: "धूप में बितावल समय: रोजाना 11 बजे से 3 बजे तक मुंह, हाथ आ पैर खुलल रहला पर धूप में कति देर रहेला?",
      options: ["बहुत कम", "30 मिनट से कम", "30 मिनट से जादे"]
    },
    q6: "सनस्क्रीन: का आप SPF 15 से ऊपर वाला सनस्क्रीन बाहर जाए से पहिले रोज लगावेला?",
    q7: "रहवास आ प्रदूषण: का आप बहुत प्रदूषित शहर में रहेला या जहवां धुंध/धुआँ बहुत रहे?",
    q8: {
      text: "विटामिन D वाला जनवरियन के खाना (माछ, अंडा) कति बार खातानी?",
      options: ["ना खातानी (पूरी तरही साकाहारी/वेगन)", "कभी-कभी अंडा/माछ", "नियमित सेवन (हफ्ता में 1 बार माछ या रोज अंडा)"]
    },
    q9: "दूध / फोर्टिफाइड खाना: का आप रोजाना 2 कप से कम दूध या दूध के सामान खातानी?",
    q10: "पाचन से जुड़ल बीमारी: का तोहरा ऐसन बीमारी बा जवन चरबी के अवशोषण में बाधा डालेला – जइसे जिगर के रोग, IBD, सिलिएक, सिस्टिक फायब्रोसिस?",
    q11: "दवाई: का आप बहुत दिन से फेनिटोइन, स्टेरॉयड, फंगल दवा, HIV वाली दवाई खा रहल बानी जवन विटामिन D पर असर डाले?",
    q12: "हड्डी के बीमारी: का तोहरा ऑस्टियोपोरोसिस, ऑस्टियोपेनिया या छोट दुर्घटना में हड्डी टूटल बा?",
    q13: {
      text: "हड्डी या कमर दर्द: का हड्डी दर्द, कमर दर्द, मांसपेशी कमजोरी या थकान रोजाना के काम पर असर डाली?",
      options: ["बार-बार / गंभीर", "कभी-कभी", "ना"]
    },
    q14: {
      text: "मांसपेशी कमजोरी: सीढ़ी चढ़े या कुरसी से उठे में दिक्कत होखेला?",
      options: ["बार-बार / गंभीर", "कभी-कभी", "ना"]
    },
    q15: {
      text: "थकान: आराम के बादो थकान, कमजोरी या ऊर्जा कम लागेला?",
      options: ["बार-बार / गंभीर", "कभी-कभी", "ना"]
    },
    q16: {
      text: "बार-बार बीमारी: का आप दूसर लोग से जादे सर्दी, खांसी, बुखार से बीमार पड़ेला?",
      options: ["बार-बार / गंभीर", "कभी-कभी", "ना"]
    },
    q17: {
      text: "मनोदशा आ ध्यान: का मन खराब रहे, चिड़चिड़ापन या ध्यान ना लागे?",
      options: ["बार-बार / गंभीर", "कभी-कभी", "ना"]
    },
q18: "विटामिन D सप्लिमेंटेशन: का रउआ ए समय या पिछिला 3 महीना में विटामिन D 60000 IU के सप्लिमेंट लेहल बा?"
  }
}
,


  tamil: {
    title: "வைட்டமின் டி குறைபாடு அபாய மதிப்பீட்டுப் படிவம்",
    name: "பெயர்",
    age: "நோயாளியின் வயது",
    gender: "நோயாளியின் பாலினம்",
    male: "ஆண்",
    female: "பெண்",
    height: "உயரம்",
    feet: "அடி",
    inches: "அங்குலம்",
    weight: "எடை",
    comorbidities: "நோயாளியின் இணை-நோய்கள்",
    diabetes: "நீரிழிவு நோய்",
    hypertension: "உயர் இரத்த அழுத்தம்",
    hypothyroidism: "ஹைப்போ தைராய்டிசம்",
    hyperthyroidism: "ஹைப்பர் தைராய்டிசம்",
    pcos: "பிசிஓஎஸ் (பாலிசிஸ்டிக் ஓவரி சிண்ட்ரோம்)",
    other: "வேறு ஏதேனும்",
    patientInitials: "நோயாளியின் பெயரின் முதல் எழுத்துக்கள்",
    heightFeet: "நோயாளியின் உயரம் (அடி)",
    heightInches: "நோயாளியின் உயரம் (அங்குலம்)",
    weightKg: "நோயாளியின் எடை (கிலோ)",
    otherComorbidity: "பிற இணை-நோய்",
    sectionA: "பிரிவு அ: அடிப்படைத் தகவல்",
    sectionB: "பிரிவு ஆ: கேள்வித்தாள்",
    cancel: "ரத்துசெய்",
    calculate: "மதிப்பெண்ணைக் கணக்கிடு",
    selectGender: "பாலினத்தைத் தேர்ந்தெடுக்கவும்",
    selectLanguage: "மொழியைத் தேர்ந்தெடுக்கவும்",
    select: "தேர்ந்தெடு",
    yes: "ஆம்",
    no: "இல்லை",
    sometimes: "சில நேரங்களில்",
    often: "அடிக்கடி/கடுமையான",
    dark: "கருமை",
    wheatish: "மாநிறம்",
    fair: "வெள்ளை",
    veryFair: "மிகவும் வெள்ளை",
    shorts: "ஷார்ட்ஸ், டி-ஷர்ட்கள், பாவாடைகள்",
    partialCoverage: "பாதி மறைக்கப்பட்ட (எ.கா. சேலை, அரை-கை)",
    fullCoverage: "முழுமையாக மூடப்பட்ட (எ.கா. புர்கா, முழு-கை)",
    more30Min: "30 நிமிடங்களுக்கு மேல்",
    less30Min: "30 நிமிடங்களுக்கு குறைவாக",
    negligible: "பொருட்படுத்த முடியாத",
    noIntake: "உட்கொள்ளவில்லை (கடுமையான சைவம்/வீகன்)",
    occasionalIntake: "அவ்வப்போது உட்கொள்ளல்",
    regularIntake: "வழக்கமான உட்கொள்ளல் (மீன் ≥1/வாரம்)",
    questions: {
      q1: {
        text: "வயது: உங்கள் வயது 50 க்கு மேல் உள்ளதா?",
        options: ["ஆம்", "இல்லை"]
      },
      q2: {
        text: "உடல் வகை: உங்கள் உடல் நிறை குறியீட்டெண் (பிஎம்ஐ) $≥ 30\\ \\text{kg/m}^2$ (அதிக எடை/உடல் பருமன்) உள்ளதா?",
        options: ["ஆம்", "இல்லை"]
      },
      q3: {
        text: "தோல் நிறம்: உங்கள் தோல் நிறம் என்ன?",
        options: ["கருமை", "மாநிறம்", "வெள்ளை", "மிகவும் வெள்ளை"]
      },
      q4: {
        text: "ஆடை நடை: நீங்கள் வெளியில் இருக்கும்போது பொதுவாக அணியும் உடை எது?",
        options: ["ஷார்ட்ஸ், டி-ஷர்ட்கள், பாவாடைகள்", "பாதி மறைக்கப்பட்ட (எ.கா. சேலை, அரை-கை சல்வார்)", "முழுமையாக மூடப்பட்ட (எ.கா. புர்கா, முழு-கை உடைகள்)"]
      },
      q5: {
        text: "வெளியில் செலவிடும் நேரம்: வழக்கமான நாளில், உங்கள் முகம், கைகள் மற்றும் கால்கள் முழுமையாகத் திறந்த நிலையில், சூரிய ஒளியில் (காலை 11 மணி முதல் மாலை 3 மணி வரை) எவ்வளவு நேரம் செலவிடுகிறீர்கள்?",
        options: ["பொருட்படுத்த முடியாத", "30 நிமிடங்களுக்கு குறைவாக", "30 நிமிடங்களுக்கு மேல்"]
      },
      q6: "சன்ஸ்கிரீன் பயன்பாடு: நீங்கள் வெளியே செல்வதற்கு முன் திறந்திருக்கும் தோலில் சன்ஸ்கிரீனை (SPF >15) தவறாமல் பயன்படுத்துகிறீர்களா?",
      q7: "இடம் & மாசு: நீங்கள் அதிக மாசுபாடு உள்ள நகர்ப்புறத்தில் அல்லது வருடத்தின் பெரும்பகுதி அடர்ந்த மூடுபனி/புகைமூட்டம் உள்ள பகுதியில் வசிக்கிறீர்களா?",
      q8: {
        text: "வைட்டமின் டி நிறைந்த விலங்கு சார்ந்த உணவுகளை (எ.கா., மீன், முட்டை) எவ்வளவு அடிக்கடி உட்கொள்கிறீர்கள்?",
        options: ["உட்கொள்ளவில்லை (கடுமையான சைவம்/வீகன்; முட்டை இல்லை, மீன் இல்லை)", "அவ்வப்போது உட்கொள்ளல் (முட்டை மட்டும் சில நாட்களில், மீன் மிகக் குறைவு அல்லது இல்லை)", "வழக்கமான உட்கொள்ளல் (மீன் $≥ 1$/வாரம் அல்லது அடிக்கடி முட்டை)"]
      },
      q9: "பால்/செறிவூட்டப்பட்ட உணவு உட்கொள்ளல்: நீங்கள் ஒரு நாளைக்கு 2 கப்களுக்கு (பரிமாறுதல்) குறைவாக பால்/பால் பொருட்களை உட்கொள்கிறீர்களா?",
      q10: "சீரற்ற உறிஞ்சுதல் நிலைகள்: கொழுப்பு உறிஞ்சுதலைப் பாதிக்கும் கல்லீரல் நோய், ஐபிடி (IBD), சீலியாக் நோய் அல்லது சிஸ்டிக் ஃபைப்ரோஸிஸ் போன்ற நோய் உங்களுக்கு இருப்பது கண்டறியப்பட்டுள்ளதா?",
      q11: "மருந்துகள்: வைட்டமின் டி வளர்சிதை மாற்றத்தைப் பாதிக்கும் ஃபெனிடோயின், ஸ்டீராய்டுகள், பூஞ்சை எதிர்ப்பு மருந்துகள் அல்லது ஆன்டிரெட்ரோவைரல் போன்ற நீண்ட கால மருந்துகளை நீங்கள் பயன்படுத்துகிறீர்களா?",
      q12: "ஆஸ்டியோபோரோசிஸ் கண்டறிதல்: உங்களுக்கு ஆஸ்டியோபோரோசிஸ், ஆஸ்டியோபீனியா இருப்பது கண்டறியப்பட்டுள்ளதா அல்லது குறைந்த அதிர்ச்சி முறிவு ஏற்பட்டுள்ளதா?",
      q13: {
        text: "எலும்பு அல்லது கீழ் முதுகு வலி: தினசரி செயல்பாட்டைப் பாதிக்கும் எலும்பு அல்லது கீழ் முதுகு வலி, தசை பலவீனம் அல்லது சோர்வு ஆகியவற்றை நீங்கள் அடிக்கடி அனுபவிக்கிறீர்களா?",
        options: ["அடிக்கடி/கடுமையான", "சில நேரங்களில்", "இல்லை"]
      },
      q14: {
        text: "தசை பலவீனம்: படிக்கட்டுகளில் ஏறுவது அல்லது நாற்காலியில் இருந்து எழுவது போன்ற சிரமத்தை (தசை பலவீனம்) அனுபவிக்கிறீர்களா?",
        options: ["அடிக்கடி/கடுமையான", "சில நேரங்களில்", "இல்லை"]
      },
      q15: {
        text: "சோர்வு: ஓய்வுக்குப் பிறகும் சோர்வாகவோ அல்லது ஆற்றல் குறைவாகவோ உணர்கிறீர்களா?",
        options: ["அடிக்கடி/கடுமையான", "சில நேரங்களில்", "இல்லை"]
      },
      q16: {
        text: "நோய்வாய்ப்படும் அதிர்வெண்: மற்றவர்களை விட அடிக்கடி நோய்வாய்ப்படுகிறீர்களா (சளி, காய்ச்சல் மற்றும் தொற்றுகள்)?",
        options: ["அடிக்கடி/கடுமையான", "சில நேரங்களில்", "இல்லை"]
      },
      q17: {
        text: "மனநிலை மற்றும் கவனம்: குறைந்த மனநிலை, எரிச்சல் அல்லது கவனம் செலுத்துவதில் சிரமம் ஆகியவற்றை நீங்கள் கவனிக்கிறீர்களா?",
        options: ["அடிக்கடி/கடுமையான", "சில நேரங்களில்", "இல்லை"]
      },
      q18: "வைட்டமின் டி / கால்சியம் சேமிப்புக் கூடுதல்: நீங்கள் வைட்டமின் D 60000 IU / கால்சியம் சேமிப்புக் கூடுதல் எடுத்துக்கொண்டீர்களா (தற்போது அல்லது கடந்த 3 மாதங்களில்)?"
    }
  }






,


  kannada: {
    title: "ವಿಟಮಿನ್ D ಕೊರತೆಯ ಅಪಾಯ ಮೌಲ್ಯಮಾಪನ ಪ್ರಶ್ನಾವಳಿ",
    name: "ಹೆಸರು",
    age: "ರೋಗಿಯ ವಯಸ್ಸು",
    gender: "ರೋಗಿಯ ಲಿಂಗ",
    male: "ಪುರುಷ",
    female: "ಮಹಿಳೆ",
    height: "ಎತ್ತರ",
    feet: "ಅಡಿ",
    inches: "ಇಂಚು",
    weight: "ತೂಕ",
    comorbidities: "ರೋಗಿಯ ಸಹರೋಗಗಳು",
    diabetes: "ಮಧುಮೇಹ",
    hypertension: "ರಕ್ತದೊತ್ತಡ",
    hypothyroidism: "ಹೈಪೊಥೈರಾಯಿಡಿಸಮ್",
    hyperthyroidism: "ಹೈಪರ್ಥೈರಾಯಿಡಿಸಮ್",
    pcos: "ಪಿಸಿಓಎಸ್ (ಪಾಲಿಸಿಸ್ಟಿಕ್ ಓವರಿ ಸಿಂಡ್ರೋಮ್)",
    other: "ಇತರೆ ಯಾವುದಾದರೂ",
    patientInitials: "ರೋಗಿಯ ಹೆಸರಿನ ಮೊದಲ ಅಕ್ಷರಗಳು",
    heightFeet: "ರೋಗಿಯ ಎತ್ತರ (ಅಡಿ)",
    heightInches: "ರೋಗಿಯ ಎತ್ತರ (ಇಂಚು)",
    weightKg: "ರೋಗಿಯ ತೂಕ (ಕೆ.ಜಿ)",
    otherComorbidity: "ಇತರೆ ಸಹರೋಗ",
    sectionA: "ವಿಭಾಗ A: ಮೂಲ ಮಾಹಿತಿ",
    sectionB: "ವಿಭಾಗ B: ಪ್ರಶ್ನಾವಳಿ",
    cancel: "ರದ್ದುಮಾಡಿ",
    calculate: "ಸ್ಕೋರ್ ಲೆಕ್ಕಿಸಿ",
    selectGender: "ಲಿಂಗವನ್ನು ಆಯ್ಕೆಮಾಡಿ",
    selectLanguage: "ಭಾಷೆಯನ್ನು ಆಯ್ಕೆಮಾಡಿ",
    select: "ಆಯ್ಕೆಮಾಡಿ",
    yes: "ಹೌದು",
    no: "ಇಲ್ಲ",
    sometimes: "ಕೆಲವೊಮ್ಮೆ",
    often: "ಆಗಾಗ / ತೀವ್ರ",
    dark: "ಕಪ್ಪು",
    wheatish: "ಗೋಧಿ",
    fair: "ಬಿಳಿ",
    veryFair: "ತುಂಬಾ ಬಿಳಿ",
    shorts: "ಶಾರ್ಟ್ಸ್, ಟಿ-ಶರ್ಟ್, ಸ್ಕರ್ಟ್",
    partialCoverage: "ಭಾಗಶಃ ಮುಚ್ಚುವ (ಉದಾ: ಸೀರೆ, ಅರ್ಧಬಾಹು)",
    fullCoverage: "ಸಂಪೂರ್ಣ ಮುಚ್ಚುವ (ಉದಾ: ಬುರ್ಖಾ, ಫುಲ್ ಸ್ಲೀವ್)",
    more30Min: "30 ನಿಮಿಷಕ್ಕಿಂತ ಹೆಚ್ಚು",
    less30Min: "30 ನಿಮಿಷಕ್ಕಿಂತ ಕಡಿಮೆ",
    negligible: "ಅತಿ ಕಡಿಮೆ",
    noIntake: "ಸೇವನೆ ಇಲ್ಲ (ನಿರಾಮಿಷ/ಶುದ್ಧ ಸಸ್ಯಾಹಾರಿ)",
    occasionalIntake: "ಕೆಲವೊಮ್ಮೆ ಸೇವನೆ",
    regularIntake: "ನಿಯಮಿತ ಸೇವನೆ (ಮೀನು ≥1/ವಾರ)",
    questions: {
      q1: {
        text: "ವಯಸ್ಸು: ನಿಮ್ಮ ವಯಸ್ಸು 50 ಕ್ಕಿಂತ ಹೆಚ್ಚು ಇದೆಯೇ?",
        options: ["ಹೌದು", "ಇಲ್ಲ"]
      },
      q2: {
        text: "ಶರೀರದ ಪ್ರಕಾರ: ನಿಮ್ಮ BMI $≥ 30\\ \\text{kg/m}^2$ (ಅತಿ ತೂಕ/ಸ್ಥೂಲಕಾಯ) ಇದೆಯೇ?",
        options: ["ಹೌದು", "ಇಲ್ಲ"]
      },
      q3: {
        text: "ಚರ್ಮದ ಬಣ್ಣ: ನಿಮ್ಮ ಚರ್ಮದ ಬಣ್ಣ ಹೇಗಿದೆ?",
        options: ["ಕಪ್ಪು", "ಗೋಧಿ", "ಬಿಳಿ", "ತುಂಬಾ ಬಿಳಿ"]
      },
      q4: {
        text: "ಉಡುಗೆ ಶೈಲಿ: ಹೊರಗೆ ಹೋಗುವಾಗ ನೀವು ಯಾವ ರೀತಿಯ ಉಡುಪನ್ನು ಧರಿಸುತ್ತೀರಿ?",
        options: ["ಶಾರ್ಟ್ಸ್, ಟಿ-ಶರ್ಟ್, ಸ್ಕರ್ಟ್", "ಭಾಗಶಃ ಮುಚ್ಚುವ (ಉದಾ: ಸೀರೆ, ಅರ್ಧಬಾಹು ಸಲ್ವಾರ್)", "ಸಂಪೂರ್ಣ ಮುಚ್ಚುವ (ಉದಾ: ಬುರ್ಖಾ, ಸಂಪೂರ್ಣ ಬಾಹು ಉಡುಪು)"]
      },
      q5: {
        text: "ಸೂರ್ಯನ ಬೆಳಕಿನಲ್ಲಿ ಕಳೆದ ಸಮಯ: ಸಾಮಾನ್ಯ ದಿನದಲ್ಲಿ, ಬೆಳಿಗ್ಗೆ 11 ರಿಂದ ಮಧ್ಯಾಹ್ನ 3ರ ವರೆಗೆ ಮುಖ, ಕೈ, ಕಾಲುಗಳನ್ನು ತೆರೆದಿಡಿ ಸೂರ್ಯನ ಬೆಳಕಿನಲ್ಲಿ ಎಷ್ಟು ಸಮಯ ಕಳೆಯುತ್ತೀರಿ?",
        options: ["ಅತಿ ಕಡಿಮೆ", "30 ನಿಮಿಷಕ್ಕಿಂತ ಕಡಿಮೆ", "30 ನಿಮಿಷಕ್ಕಿಂತ ಹೆಚ್ಚು"]
      },
      q6: "ಸನ್ಸ್ಕ್ರೀನ್ ಬಳಕೆ: SPF >15 ಇರುವ ಸನ್ಸ್ಕ್ರೀನ್ ಅನ್ನು ಹೊರಗೆ ಹೋಗುವ ಮುನ್ನ ನಿಯಮಿತವಾಗಿ ಬಳಿಸುತ್ತೀರಾ?",
      q7: "ಸ್ಥಳ ಮತ್ತು ಮಾಲಿನ್ಯ: ನೀವು ಹೆಚ್ಚು ಮಾಲಿನ್ಯ ಇರುವ ನಗರ ಪ್ರದೇಶದಲ್ಲಿ ಅಥವಾ ವರ್ಷದಲ್ಲಿನ ಹೆಚ್ಚಿನ ಸಮಯ ಹೊಗೆಯುಳ್ಳ ಪ್ರದೇಶದಲ್ಲಾ ವಾಸಿಸುತ್ತೀರಾ?",
      q8: {
        text: "ವಿಟಮಿನ್ D ಸಮೃದ್ಧ ಪ್ರಾಣಿಜ ಆಹಾರ (ಮೀನು, ಮೊಟ್ಟೆ) ಸೇವನೆ ಎಷ್ಟು?",
        options: ["ಸೇವನೆ ಇಲ್ಲ (ನಿರಾಮಿಷ/ಶುದ್ಧ ಸಸ್ಯಾಹಾರಿ – ಮೊಟ್ಟೆ ಇಲ್ಲ, ಮೀನು ಇಲ್ಲ)", "ಕೆಲವೊಮ್ಮೆ ಸೇವನೆ (ಮೊಟ್ಟೆ ಕೆಲ ದಿನಗಳಲ್ಲಿ, ಮೀನು ಅಪರೂಪವಾಗಿ)", "ನಿಯಮಿತ ಸೇವನೆ (ಮೀನು ≥1/ವಾರ ಅಥವಾ ಮೊಟ್ಟೆ ನಿಯಮಿತವಾಗಿ)"]
      },
      q9: "ಹಾಲು/ಪೌಷ್ಟಿಕ ಆಹಾರ ಸೇವನೆ: ನೀವು ದಿನಕ್ಕೆ 2 ಕಪ್ಗಿಂತ ಕಡಿಮೆ ಹಾಲು/ಹಾಲಿನ ಉತ್ಪನ್ನಗಳನ್ನು ಸೇವಿಸ್ತೀರಾ?",
      q10: "ಆಹಾರ ಶೋಷಣೆಗೆ ಸಂಬಂಧಿಸಿದ ಕಾಯಿಲೆಗಳು: ಯಕೃತ್ತಿನ ರೋಗ, IBD, ಸಿಲಿಯಾಕ್ ರೋಗ ಅಥವಾ ಸಿಸ್ಟಿಕ್ ಫೈಬ್ರೋಸಿಸ್ ನಿಮಗೆ ಇದೆಯೇ?",
      q11: "ಔಷಧಿಗಳು: ಫೆನಿಟೊಯಿನ್, ಸ್ಟೆರಾಯ್ಡ್ಸ್, ಅಂಟಿಫಂಗಲ್ ಅಥವಾ ART ಔಷಧಿಗಳನ್ನು ದೀರ್ಘಕಾಲದಿಂದ ಬಳಸುತ್ತೀರಾ?",
      q12: "ಎಲುಬು ಸಮಸ್ಯೆಗಳು: ಆಸ್ಟಿಯೋಪೋರೋಸಿಸ್, ಆಸ್ಟಿಯೋಪೀನಿಯಾ ಅಥವಾ ಸಣ್ಣ ಗಾಯಕ್ಕೂ ಎಲುಬು ಮುರಿತ?",
      q13: {
        text: "ಎಲುಬು ಅಥವಾ ಬೆನ್ನು ನೋವು, ಸ್ನಾಯು ಬಲಹೀನತೆ, ದಣಿವು:",
        options: ["ಆಗಾಗ / ತೀವ್ರ", "ಕೆಲವೊಮ್ಮೆ", "ಇಲ್ಲ"]
      },
      q14: {
        text: "ಮೆಟ್ಟಿಲು ಹತ್ತುವಾಗ ಅಥವಾ ಕುರ್ಚಿಯಿಂದ ಎದ್ದೇಳುವಾಗ ತೊಂದರೆ (ಸ್ನಾಯು ಬಲಹೀನತೆ):",
        options: ["ಆಗಾಗ / ತೀವ್ರ", "ಕೆಲವೊಮ್ಮೆ", "ಇಲ್ಲ"]
      },
      q15: {
        text: "ವಿಶ್ರಾಂತಿಯ ನಂತರವೂ ದಣಿವು/ಶಕ್ತಿ ಕಡಿಮೆ:",
        options: ["ಆಗಾಗ / ತೀವ್ರ", "ಕೆಲವೊಮ್ಮೆ", "ಇಲ್ಲ"]
      },
      q16: {
        text: "ಸಣ್ಣ ಜ್ವರ/ಶೀತ/ಇನ್ಫೆಕ್ಷನ್ ಆಗುವ ಪ್ರಮಾಣ:",
        options: ["ಆಗಾಗ / ತೀವ್ರ", "ಕೆಲವೊಮ್ಮೆ", "ಇಲ್ಲ"]
      },
      q17: {
        text: "ಮನೋಭಾವ ಕುಗ್ಗುವುದು, ಕೋಪ, ಏಕಾಗ್ರತೆಯ ಕೊರತೆ:",
        options: ["ಆಗಾಗ / ತೀವ್ರ", "ಕೆಲವೊಮ್ಮೆ", "ಇಲ್ಲ"]
      },
q18: "ವಿಟಮಿನ್ D ಪೂರಕ ಸೇವನೆ: ನೀವು ಈಗ ಅಥವಾ ಕಳೆದ 3 ತಿಂಗಳಲ್ಲಿ ವಿಟಮಿನ್ D  60000 IU ಪೂರಕವನ್ನು ತೆಗೆದುಕೊಂಡಿದ್ದೀರಾ?"
    }
  }

,

gujarati: {
  title: "વિટામિન D ની અછતનું જોખમ મૂલ્યાંકન પ્રશ્નાવલી",
  name: "નામ",
  age: "રોગીની ઉંમર",
  gender: "રોગીનું લિંગ",
  male: "પુરુષ",
  female: "સ્ત્રી",
  height: "ઉંચાઈ",
  feet: "ફૂટ",
  inches: "ઈંચ",
  weight: "વજન",
  comorbidities: "રોગીના સહ-રોગો",
  diabetes: "ડાયાબિટીસ",
  hypertension: "હાઈ બ્લડ પ્રેશર",
  hypothyroidism: "હાઇપોથાયરોઇડિઝમ",
  hyperthyroidism: "હાઇપરથાયરોઇડિઝમ",
  pcos: "પી.સી.ઓ.એસ. (પોલીસિસ્ટિક ઓવરી સિન્ડ્રોમ)",
  other: "અન્ય",
  patientInitials: "રોગીના શરૂઆતના અક્ષરો",
  heightFeet: "રોગીની ઉંચાઈ (ફૂટ)",
  heightInches: "રોગીની ઉંચાઈ (ઈંચ)",
  weightKg: "રોગીનું વજન (કિ.ગ્રા.)",
  otherComorbidity: "અન્ય સહ-રોગ",
  sectionA: "વિભાગ A: મૂળભૂત માહિતી",
  sectionB: "વિભાગ B: પ્રશ્નાવલી",
  cancel: "રદ કરો",
  calculate: "સ્કોર ગણો",
  selectGender: "લિંગ પસંદ કરો",
  selectLanguage: "ભાષા પસંદ કરો",
  select: "પસંદ કરો",
  yes: "હા",
  no: "ના",
  sometimes: "ક્યારેક",
  often: "વારંવાર / ગંભીર",
  dark: "ગાઢ",
  wheatish: "ઘઉંવર્ણ",
  fair: "ઉજળો",
  veryFair: "ખૂબ ઉજળો",
  shorts: "શોર્ટ્સ, ટી-શર્ટ, સ્કર્ટ",
  partialCoverage: "અડધી આવરતી (જેમ કે સાડી, અડધી બાંયવાળી સલવાર)",
  fullCoverage: "સંપૂર્ણ આવરતી (જેમ કે બુરખો, લાંબી બાંયવાળા કપડાં)",
  more30Min: "30 મિનિટથી વધુ",
  less30Min: "30 મિનિટથી ઓછું",
  negligible: "ખૂબ ઓછું",
  noIntake: "નથી લેતા (શુદ્ધ શાકાહારી/વેગન)",
  occasionalIntake: "ક્યારેક લેતા",
  regularIntake: "નિયમિતપણે (માછલી ≥1/અઠવાડિયો)",

  questions: {
    q1: {
      text: "ઉંમર: શું તમારી ઉંમર 50 વર્ષથી વધુ છે?",
      options: ["હા", "ના"]
    },
    q2: {
      text: "શારીરિક પ્રકાર: શું તમારું BMI ≥ 30 કિ.ગ્રા./મી² (મોટાપો)?",
      options: ["હા", "ના"]
    },
    q3: {
      text: "ત્વચાનું પિગમેન્ટેશન: તમારી ત્વચાનો રંગ કેવો છે?",
      options: ["ગાઢ", "ઘઉંવર્ણ", "ઉજળો", "ખૂબ ઉજળો"]
    },
    q4: {
      text: "કપડાંની શૈલી: બહાર જતા સમયે તમે કયા પ્રકારના કપડાં પહેરો છો?",
      options: ["શોર્ટ્સ, ટી-શર્ટ, સ્કર્ટ", "અડધી આવરતી (જેમ કે સાડી, અડધી બાંયવાળી સલવાર)", "સંપૂર્ણ આવરતી (જેમ કે બુરખો, લાંબી બાંયવાળા કપડાં)"]
    },
    q5: {
      text: "સૂર્યપ્રકાશમાં વિતાવેલો સમય: સામાન્ય દિવસે 11 થી 3 વચ્ચે, ચહેરો, હાથ અને પગ ખુલ્લા રાખીને કેટલો સમય સૂર્યપ્રકાશમાં વિતાવો છો?",
      options: ["ખૂબ ઓછું", "30 મિનિટથી ઓછું", "30 મિનિટથી વધુ"]
    },
    q6: "સનસ્ક્રીન: શું તમે SPF >15 સનસ્ક્રીન નિયમિતપણે લગાવો છો?",
    q7: "સ્થાન અને પ્રદૂષણ: શું તમે ભારે પ્રદૂષણ અથવા સ્મોગવાળા વિસ્તારમાં રહો છો?",
    q8: {
      text: "વિટામિન D સમૃદ્ધ પ્રાણિજ ખોરાક (માછલી, ઈંડા) કેટલું કરો છો?",
      options: ["નથી લેતા (શુદ્ધ શાકાહારી/વેગન)", "ક્યારેક લેતા (ઈંડા અઠવાડિયામાં થોડા, માછલી બહુ ઓછી)", "નિયમિતપણે (માછલી ≥1/અઠવાડિયો અથવા ઈંડા વારંવાર)"]
    },
    q9: "દૂધ/ફોર્ટિફાઈડ ખોરાક: શું તમે દરરોજ 2 કપથી ઓછું દૂધ લો છો?",
    q10: "શોષણ બીમારીઓ: શું તમને લીવર, IBD, સિલિએક અથવા સિસ્ટિક ફાઈબ્રોસિસ છે?",
    q11: "દવાઓ: શું તમે ફેનિટોઇન, સ્ટેરોઇડ, એન્ટિફંગલ અથવા એન્ટીરેટ્રોવાયરલ લાંબા સમયથી લો છો?",
    q12: "હાડકાં: શું તમને ઓસ્ટિયોપોરોસિસ/ઓસ્ટિયોપેનિયા અથવા નાની ઈજા પર ફ્રેક્ચર થયું છે?",
    q13: {
      text: "હાડકાં/પીઠનો દુખાવો: શું તમને હાડકાંનો દુખાવો, પીઠનો દુખાવો અથવા સ્નાયુ નબળાઈ વારંવાર થાય છે?",
      options: ["વારંવાર / ગંભીર", "ક્યારેક", "ના"]
    },
    q14: {
      text: "સ્નાયુ નબળાઈ: સીડીઓ ચડવા અથવા ખુરશી પરથી ઊઠવામાં તકલીફ પડે છે?",
      options: ["વારંવાર / ગંભીર", "ક્યારેક", "ના"]
    },
    q15: {
      text: "થાક: પૂરતો આરામ કર્યા પછી પણ થાક લાગે છે?",
      options: ["વારંવાર / ગંભીર", "ક્યારેક", "ના"]
    },
    q16: {
      text: "ચેપ: શું તમે અન્ય લોકો કરતાં વધુ વાર બીમાર પડો છો?",
      options: ["વારંવાર / ગંભીર", "ક્યારેક", "ના"]
    },
    q17: {
      text: "મૂડ/એકાગ્રતા: શું તમને મૂડ નબળો, ચીડચીડાપણું કે એકાગ્રતા ઘટે છે?",
      options: ["વારંવાર / ગંભીર", "ક્યારેક", "ના"]
    },
q18: "વિટામિન D સપ્લિમેન્ટેશન: શું તમે હાલમાં અથવા છેલ્લા 3 મહિનામાં વિટામિન D 60000 IU સપ્લિમેન્ટ લીધું છે?"
  }
}
,
malayalam: {
  title: "വിറ്റാമിൻ D കുറവിന്റെ അപകടസാധ്യതാ മൂല്യനിർണയ ചോദ്യാവലി",
  name: "പേര്",
  age: "രോഗിയുടെ പ്രായം",
  gender: "രോഗിയുടെ ലിംഗം",
  male: "പുരുഷൻ",
  female: "സ്ത്രീ",
  height: "ഉയരം",
  feet: "അടി",
  inches: "ഇഞ്ച്",
  weight: "ഭാരം",
  comorbidities: "രോഗിയുടെ സഹരോഗങ്ങൾ",
  diabetes: "പ്രമേഹം",
  hypertension: "ഉയർന്ന രക്തസമ്മർദ്ദം",
  hypothyroidism: "ഹൈപ്പോതൈറോയിഡിസം",
  hyperthyroidism: "ഹൈപ്പർതൈറോയിഡിസം",
  pcos: "പിസിഒഎസ് (പോളിസിസ്റ്റിക് ഓവറി സിന്‍ഡ്രോം)",
  other: "മറ്റുള്ളത്",
  patientInitials: "രോഗിയുടെ തുടക്കക്ഷരങ്ങൾ",
  heightFeet: "രോഗിയുടെ ഉയരം (അടി)",
  heightInches: "രോഗിയുടെ ഉയരം (ഇഞ്ച്)",
  weightKg: "രോഗിയുടെ ഭാരം (കിലോ)",
  otherComorbidity: "മറ്റു സഹരോഗങ്ങൾ",
  sectionA: "വിഭാഗം A: അടിസ്ഥാന വിവരങ്ങൾ",
  sectionB: "വിഭാഗം B: ചോദ്യാവലി",
  cancel: "റദ്ദാക്കുക",
  calculate: "സ്കോർ കണക്കാക്കുക",
  selectGender: "ലിംഗം തിരഞ്ഞെടുക്കുക",
  selectLanguage: "ഭാഷ തിരഞ്ഞെടുക്കുക",
  select: "തിരഞ്ഞെടുക്കുക",
  yes: "ഉണ്ട്",
  no: "ഇല്ല",
  sometimes: "ചിലപ്പോൾ",
  often: "പലപ്പോഴും / ഗുരുതരം",
  dark: "ഇരുണ്ട",
  wheatish: "ഗോതമ്പ് നിറം",
  fair: "വെളുത്ത",
  veryFair: "വളരെ വെളുത്ത",
  shorts: "ഷോർട്സ്, ടി-ഷർട്ട്, സ്കർട്ട്",
  partialCoverage: "ഭാഗികമായി മൂടുന്ന വസ്ത്രങ്ങൾ (സാരി, ഹാഫ് സ്ലീവ്)",
  fullCoverage: "പൂർണ്ണമായി മൂടുന്ന വസ്ത്രങ്ങൾ (ബുർഖ, ഫുൾ സ്ലീവ്)",
  more30Min: "30 മിനിറ്റിൽ കൂടുതൽ",
  less30Min: "30 മിനിറ്റിൽ കുറവ്",
  negligible: "വളരെ കുറവ്",
  noIntake: "ഇല്ല (ശുദ്ധ സസ്യാഹാരി/വെഗൻ)",
  occasionalIntake: "ചിലപ്പോൾ കഴിക്കുന്നു",
  regularIntake: "സ്ഥിരമായി (മീൻ ≥ ആഴ്ചയിൽ 1 പ്രാവശ്യം)",

  questions: {
    q1: {
      text: "പ്രായം: നിങ്ങൾക്ക് 50 വയസ്സിനും കൂടുതലോ?",
      options: ["ഉണ്ട്", "ഇല്ല"]
    },
    q2: {
      text: "ശരീരഘടന: നിങ്ങളുടെ BMI ≥ 30 kg/m² (അധികഭാരം/വളർന്ന ഭാരം) ആണോ?",
      options: ["ഉണ്ട്", "ഇല്ല"]
    },
    q3: {
      text: "തൊലി നിറം: നിങ്ങളുടെ തൊലിയുടെ നിറം എന്താണ്?",
      options: ["ഇരുണ്ട", "ഗോതമ്പ് നിറം", "വെളുത്ത", "വളരെ വെളുത്ത"]
    },
    q4: {
      text: "വസ്ത്രധാരണം: പുറത്തുപോകുമ്പോൾ നിങ്ങൾ ധരിക്കുന്ന വസ്ത്രങ്ങളുടെ രീതി എന്താണ്?",
      options: ["ഷോർട്സ്, ടി-ഷർട്ട്, സ്കർട്ട്", "ഭാഗികമായി മൂടുന്ന (സാരി, ഹാഫ് സ്ലീവ്)", "പൂർണ്ണമായി മൂടുന്ന (ബുർഖ, ഫുൾ സ്ലീവ്)"]
    },
    q5: {
      text: "സൂര്യപ്രകാശത്തിൽ സമയം: 11AM - 3PM വരെ മുഖം, കൈ, കാൽ തുറന്നു എത്ര സമയം ചിലവഴിക്കുന്നു?",
      options: ["വളരെ കുറവ്", "30 മിനിറ്റിൽ കുറവ്", "30 മിനിറ്റിൽ കൂടുതൽ"]
    },
    q6: "സൺസ്ക്രീൻ ഉപയോഗം: SPF >15 ഉള്ള സൺസ്ക്രീൻ നിങ്ങൾ സ്ഥിരമായി ഉപയോഗിക്കുമോ?",
    q7: "പ്രദേശവും മലിനീകരണവും: തീരെ മലിനമായ / മൂടൽമഞ്ഞ് കൂടുതലുള്ള പ്രദേശത്താണോ താമസം?",
    q8: {
      text: "വിട്ടാമിൻ D ധാരാളമുള്ള മാംസാഹാരം (മീൻ, മുട്ട) എത്രത്തോളം കഴിക്കുന്നു?",
      options: ["ഇല്ല (വെഗൻ/ശുദ്ധ സസ്യാഹാരി)", "ചിലപ്പോൾ (മുട്ട കുറച്ച്, മീൻ വളരെ കുറച്ച്)", "സ്ഥിരമായി (മീൻ ≥1/ആഴ്ച അല്ലെങ്കിൽ മുട്ട നിരന്തരം)"]
    },
    q9: "പാൽ/ഫോർട്ടിഫൈഡ് ഭക്ഷണം: ദിവസം 2 കപ്പ് താഴെ പാൽ/പാൽ ഉൽപ്പന്നങ്ങൾ മാത്രമോ?",
    q10: "അവശോഷണ സംബന്ധമായ രോഗങ്ങൾ: ലിവർ രോഗം, IBD, സീലിയാക്, സിസ്റ്റിക് ഫൈബ്രോസിസ് തുടങ്ങിയ പ്രശ്നങ്ങളുണ്ടോ?",
    q11: "മരുന്നുകൾ: ഫെനിറ്റോയിൻ, സ്റ്റിറോയിഡ്, ആന്റിഫംഗൽ അല്ലെങ്കിൽ ആന്റിരെട്രോവൈറൽ മരുന്നുകൾ ദീർഘകാലം ഉപയോഗിക്കുന്നുണ്ടോ?",
    q12: "എല്ലുകൾ: ഓസ്റ്റിയോപ്പോറോസിസ്/ഓസ്റ്റിയോപീനിയ അല്ലെങ്കിൽ ചെറിയ പരിക്കിൽ എല്ല് പൊട്ടിയിട്ടുണ്ടോ?",
    q13: {
      text: "എല്ല്/പിൻസ് വേദന: എല്ല്, പുറംവേദന, പേശിദൗർബല്യം, ക്ഷീണം എന്നിവ ഉണ്ടോ?",
      options: ["പലപ്പോഴും / ഗുരുതരം", "ചിലപ്പോൾ", "ഇല്ല"]
    },
    q14: {
      text: "പേശി ദൗർബല്യം: പടികൾ കയറുമ്പോൾ/കസേരയിൽ നിന്ന് എഴുന്നേൽക്കുമ്പോൾ ബുദ്ധിമുട്ടുണ്ടോ?",
      options: ["പലപ്പോഴും / ഗുരുതരം", "ചിലപ്പോൾ", "ഇല്ല"]
    },
    q15: {
      text: "ക്ഷീണം: വിശ്രമിച്ചതിനുശേഷവും ക്ഷീണം അനുഭവപ്പെടുന്നുണ്ടോ?",
      options: ["പലപ്പോഴും / ഗുരുതരം", "ചിലപ്പോൾ", "ഇല്ല"]
    },
    q16: {
      text: "അണുബാധകൾ: മറ്റുള്ളവരെക്കാൾ കൂടുതലായി തണുപ്പ്, പനി, അണുബാധകൾ ഉണ്ടോ?",
      options: ["പലപ്പോഴും / ഗുരുതരം", "ചിലപ്പോൾ", "ഇല്ല"]
    },
    q17: {
      text: "മനോഭാവം/ശ്രദ്ധ: മനോഭാവം താഴ്ന്നത്, അസഹിഷ്ണുത, ശ്രദ്ധക്കുറവ് അനുഭവപ്പെടുന്നുണ്ടോ?",
      options: ["പലപ്പോഴും / ഗുരുതരം", "ചിലപ്പോൾ", "ഇല്ല"]
    },
q18: "വിട്ടാമിൻ D സപ്ലിമെന്റേഷൻ: ഇപ്പോൾ അല്ലെങ്കിൽ കഴിഞ്ഞ 3 മാസത്തിനുള്ളിൽ നിങ്ങൾ വിട്ടാമിൻ D 60000 IU സപ്ലിമെന്റ് എടുത്തിട്ടുണ്ടോ?"
  }
}
,

};
